// src/mocks/handlers/auth/refreshTokenHandler.ts

import { rest } from 'msw';
import { TokenResponse, ErrorResponse } from '@/domains/auth/auth.types';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import {
  refreshTokenExpiry,
  resetAccessTokenExpiry,
} from '@/mocks/data/tokenTimers';

export const refreshTokenHandler = rest.post<
  { refresh_token: string },
  TokenResponse | ErrorResponse
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_REFRESH_TOKEN}`,
  (req, res, ctx) => {
    const now = Date.now();

    const { refresh_token } = req.body;

    console.warn('Refresh Token:', refresh_token);

    if (!refresh_token || refresh_token !== 'mock_refresh_token') {
      return res(ctx.status(401), ctx.json({ error: 'Invalid refresh token' }));
    }

    if (now > refreshTokenExpiry) {
      return res(
        ctx.status(401),
        ctx.json({ error: 'Refresh token has expired' }),
      );
    }

    resetAccessTokenExpiry();

    return res(
      ctx.status(200),
      ctx.json({ access_token: 'new_mock_access_token' }),
    );
  },
);
